import { HStack, Separator, Text } from "@chakra-ui/react"
import { useColorModeValue } from "@pathwright/ux/src/components/chakra/ui/color-mode"
import { useScopedTranslation } from "@pathwright/ux/src/components/lng/useScopedTranslation"

const AuthOptionsDivider = (): JSX.Element => {
  const { t } = useScopedTranslation("auth.auth_options_divider")
  const color = useColorModeValue("contentTextSecondary", "white")

  return (
    <HStack w="100%">
      <Separator
        borderBottomWidth={0}
        borderTopWidth="1px"
        w="full"
        borderColor={color}
      />
      <Text color={color}>{t("or")}</Text>
      <Separator
        borderBottomWidth={0}
        borderTopWidth="1px"
        w="full"
        borderColor={color}
      />
    </HStack>
  )
}

export default AuthOptionsDivider
